import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=28bc04af&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=28bc04af&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28bc04af",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28bc04af')) {
      api.createRecord('28bc04af', component.options)
    } else {
      api.reload('28bc04af', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=28bc04af&scoped=true&", function () {
      api.rerender('28bc04af', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-22a5O1PPu9upJ/JS/comp/PopupBox.vue"
export default component.exports